import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
import { Booking } from '@/entities/Booking'
import { Profile } from '@/entities/Profile'
import { Facility } from '@/entities/Facility'
import { Room } from '@/entities/Room'
import { BookingType } from '@/entities/BookingType'
import { Guest } from '@/entities/Guest'
import { GuestType } from '@/entities/GuestType'
import { Settings } from '@/entities/Settings'
import { Currency } from '@/entities/Currency'
const requestService = new RequestService()

export class MeRequests {
  getBookings () {
    const route = ServerDirections.ME_BOOKINGS
    const method = 'get'
    function map (data) {
      return data.map((item) => {
        return {
          booking: new Booking(item.booking),
          profile: new Profile(item.profile),
          bookingType: item.booking_type ? new BookingType(item.booking_type) : null,
          facility: new Facility(item.facility),
          rooms: item.rooms.map((roomWithAccount) => {
            return {
              room: new Room(roomWithAccount.room),
              accountId: roomWithAccount.account_id,
            }
          }),
          guests: item.guests.map((g) => {
            return {
              guest: new Guest(g.guest),
              profile: new Profile(g.profile),
              registrationCard: null,
              type: g.type ? new GuestType(g.type) : null,
            }
          }),
        }
      })
    }
    return requestService.makePromise(route, method, {}, map)
  }

  getSettings () {
    const route = ServerDirections.ME_SETTINGS
    const method = 'get'
    function map (data) {
      return new Settings(data)
    }
    return requestService.makePromise(route, method, {}, map)
  }

  getFacility () {
    const route = ServerDirections.ME_FACILITIES
    const method = 'get'
    function map (data) {
      return new Facility(data)
    }
    return requestService.makePromise(route, method, {}, map)
  }

  getRegistrationCards () {
    const route = ServerDirections.ME_REGISTRATION_CARDS
    const method = 'get'
    function map (data) {
      return data
    }
    return requestService.makePromise(route, method, {}, map)
  }

  putSettings (languageCode, displayCurrencyId, timeFormat, firstDayOfWeek) {
    const route = ServerDirections.ME_SETTINGS
    const method = 'put'
    function map (data) {
      return data
    }
    const body = {
      language_code: languageCode,
      display_currency_id: displayCurrencyId,
      time_format: timeFormat,
      first_day_of_week: firstDayOfWeek,
    }
    return requestService.makePromise(route, method, { body }, map)
  }

  putPassword (oldPassword, newPassword) {
    const route = ServerDirections.ME_PASSWORD
    const method = 'put'
    function map (data) {
      return data
    }
    const body = {
      current_password: oldPassword,
      new_password: newPassword,
    }
    return requestService.makePromise(route, method, { body }, map)
  }

  listCurrencies () {
    const route = ServerDirections.CURRENCIES
    const method = 'get'
    const map = (data) => {
      return data.map(item => ({
        currency: new Currency(item.currency),
        exchangeRate: item.exchange_rate,
      }))
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
